module.exports = __webpack_public_path__ + "static/media/006-clouds.b4b0b214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/006-clouds.png
// module id = 597
// module chunks = 0